import * as React from 'react';

import type {ThreadType} from 'nutshell-graphql-types';

import {LoadingPage} from '../../loading-page/loading-page';

import {EmptyState} from '../sidebar/empty-state';
import type {CantSendStatusEnum, Recipient} from '../types';

import {ChannelContainer} from './channel-container';

import styles from './channel-view-layout.module.css';

type Props = {
    contentFillsContainer?: boolean;
    onSend?: (input: {content: string; snoozeDuration?: number}) => Promise<any>;
    isLoadingTextables?: boolean;
    isAutoSelectingTextable?: boolean;
    isLoadingChannelEvents: boolean;
    recipient: Recipient | null | undefined;
    noValidRecipients?: boolean;
    isSendComplete?: boolean;
    isSendFailed?: boolean;
    channelEvents: any[];
    fetchMoreRows: () => any;
    hasNextPage: boolean;
    onResendMessage?: (messageId: string) => Promise<any>;
    onDeleteMessage?: (messageId: string) => Promise<any>;
    openedFromEntityName?: string | null | undefined;
    cantSendStatus: CantSendStatusEnum | null | undefined;
    onCloseSidebar: () => void;
    fetchMostRecentChannelEvents: () => Promise<any>;
    refetchScheduledChannelEvents: () => Promise<any>;
    isStartingNewThread?: boolean;
    setIsStartingNewThread?: (arg1: boolean) => void;
    setViewOpenThread?: () => void | null | undefined;
    canStartNewThreads?: boolean;
    sessionId?: string;
    threadId?: string;
    threadType?: ThreadType;
    shouldScrollToBottomOnInitialLoad?: boolean;
    isSidebar?: boolean;
    shouldHideMessageInput?: boolean;
};

export function ChannelViewLayout(props: Props) {
    const {noValidRecipients, recipient, isLoadingTextables, ...restProps} = props;

    // This is fast, no need for a distracting spinner
    if (isLoadingTextables) {
        return null;
    }

    const showSelectARecipient = !props.isAutoSelectingTextable && !recipient && !noValidRecipients;
    const isSpecialState =
        noValidRecipients || showSelectARecipient || props.isAutoSelectingTextable;

    return (
        <>
            {isSpecialState ? (
                <div className='mt-64'>
                    {noValidRecipients && (
                        <EmptyState
                            imageSrc={'no-messages'}
                            text={`There is no phone number associated with ${
                                props.openedFromEntityName || 'this entity'
                            }. Please add a phone number and try again.`}
                        />
                    )}
                    {showSelectARecipient && <EmptyState text='Select a recipient above' />}
                    {props.isAutoSelectingTextable && <LoadingPage />}
                </div>
            ) : (
                <div
                    className={
                        props.contentFillsContainer ? 'full-height' : styles['content-container']
                    }
                >
                    {/* @ts-expect-error */}
                    {props.recipient && <ChannelContainer {...restProps} recipient={recipient} />}
                </div>
            )}
        </>
    );
}
